import React, { useState } from "react";
import { IonIcon, IonImg } from "@ionic/react";
import {
  logOutOutline,
  menuOutline,
  homeOutline,
  personOutline,
  calendarOutline,
  documentTextOutline,
  medicalOutline,
  timeOutline,
} from "ionicons/icons";
import "./Menu.css";
import useMenu from "./useMenu";
import { Typography } from "@mui/joy";

const appPages = [
  {
    title: "Inicio",
    url: "/portal/Inicio",
    icon: homeOutline,
  },
  {
    title: "Mis Datos",
    url: "/portal/Datos",
    icon: personOutline,
  },
  {
    title: "Reservar Turno",
    url: "/portal/Reservar turno",
    icon: calendarOutline,
  },
  {
    title: "Mis Turnos",
    url: "/portal/Turnos",
    icon: medicalOutline,
  },
  {
    title: "Horarios Prestadores",
    url: "/portal/Horarios",
    icon: timeOutline,
  },
  /* Temporalmente oculto - Mis Estudios
  {
    title: "Mis Estudios",
    url: "/portal/Estudios",
    icon: documentTextOutline,
  },
  */
];

const HeaderMenu = (props) => {
  const { usuario, mostrarNotificacion, cerrarSesion } = useMenu();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleLogout = () => {
    closeMenu(); // Cerrar el menú primero
    cerrarSesion(); // Luego cerrar sesión
  };

  return (
    <header className="tech-header">
      <div className="tech-header-logo-container">
        <IonImg
          src={props.logoSrc || "/assets/icon/logo-cuadrado.png"}
          className="tech-header-logo"
        />
        <Typography className="tech-header-title">Portal Pacientes</Typography>
      </div>

      {/* Menú horizontal para pantallas grandes */}
      <nav className="menu-horizontal tech-header-nav">
        {appPages.map((appPage, index) => (
          <a
            key={index}
            href={appPage.url}
            className="tech-header-link"
            onMouseEnter={(e) => (e.target.style.color = "#5153B3")}
            onMouseLeave={(e) => (e.target.style.color = "#3A3D99")}
          >
            {appPage.title}
          </a>
        ))}
      </nav>

      {/* Botón hamburguesa para pantallas pequeñas */}
      <IonIcon
        icon={menuOutline}
        className="menu-hamburguesa tech-header-hamburguesa"
        onClick={toggleMenu}
      />
      {isMenuOpen && (
        <div className="menu-desplegable tech-header-dropdown">
          {appPages.map((appPage, index) => (
            <a
              key={index}
              href={appPage.url}
              className="menu-item tech-header-dropdown-link"
              onClick={closeMenu}
              onMouseEnter={(e) => {
                e.target.style.background =
                  "linear-gradient(135deg, #007BFF, #2C7BE5)";
                e.target.style.color = "white";
                e.target.style.transform = "translateX(10px)";
              }}
              onMouseLeave={(e) => {
                e.target.style.background = "transparent";
                e.target.style.color = "#212529";
                e.target.style.transform = "translateX(0)";
              }}
            >
              <IonIcon
                icon={appPage.icon}
                className="tech-header-dropdown-icon"
              />
              {appPage.title}
            </a>
          ))}
          <div className="tech-header-dropdown-separator" />
          <button
            className="menu-item logout-item tech-header-dropdown-logout"
            onClick={handleLogout}
            onMouseEnter={(e) => {
              e.target.style.background =
                "linear-gradient(135deg, #dc3545, #c82333)";
              e.target.style.color = "white";
              e.target.style.transform = "translateX(10px)";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "transparent";
              e.target.style.color = "#dc3545";
              e.target.style.transform = "translateX(0)";
            }}
          >
            <IonIcon
              icon={logOutOutline}
              className="tech-header-dropdown-logout-icon"
            />
            Cerrar Sesión
          </button>
        </div>
      )}

      <div
        className="tech-header-logout"
        onClick={cerrarSesion}
        onMouseEnter={(e) => {
          e.currentTarget.style.background =
            "linear-gradient(90deg, #fe506ca1 0%, #fe506ca1 100%)";
          e.currentTarget.style.boxShadow =
            "0 4px 16px rgba(254, 80, 108, 0.25)";
          const children = e.currentTarget.children;
          if (children.length > 0) {
            const textNode = children[0].querySelector("span") || children[0];
            textNode.style.color = "#fff";
          }
          if (children.length > 1) {
            children[1].style.color = "#fff";
          }
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background =
            "linear-gradient(90deg, #ffe5d9 0%, #ffb899 100%)";
          e.currentTarget.style.boxShadow =
            "0 2px 8px rgba(254, 80, 108, 0.15)";
          const children = e.currentTarget.children;
          if (children.length > 0) {
            const textNode = children[0].querySelector("span") || children[0];
            textNode.style.color = "#fe506ca1";
          }
          if (children.length > 1) {
            children[1].style.color = "#fe506ca1";
          }
        }}
        title="Cerrar Sesión"
      >
        <Typography className="tech-header-logout-text">
          Cerrar Sesión
        </Typography>
        <IonIcon icon={logOutOutline} className="tech-header-logout-icon" />
      </div>
    </header>
  );
};

export default HeaderMenu;
